export default __webpack_public_path__ + "static/media/SFUIText-Regular.865a0aa3.woff";